import { useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import Table from "../../../components/Table";
import { IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";

const DetailsTable = (props) => {
  const { reportUser, handleSelectIaResult } = props;

  const handleRowClick = (iaResult) => {
    handleSelectIaResult(iaResult);
  };

  const columns = useMemo(
    () => [
      {
        id: "name",
        Header: () => <div className="table-title">ATTEMPT DATE</div>,
        accessorFn: (row) =>
          row.attemptDate
            ? moment.utc(row.attemptDate).format("MMM DD, YYYY hh:mma")
            : "",
        header: "Name",
        sortingFn: (rowA, rowB) => {
          const dateA = rowA.original.attemptDate
            ? new Date(rowA.original.attemptDate)
            : new Date(0);
          const dateB = rowB.original.attemptDate
            ? new Date(rowB.original.attemptDate)
            : new Date(0);
          return dateA - dateB;
        },
        enableColumnFilter: false,
        size: 100,
      },
      {
        header: "module",
        Header: () => <div className="table-title">MODULE</div>,
        accessorFn: (row) => row.name,
        accessorKey: "procedure",
        enableColumnFilter: false,
        size: 100,
      },
      {
        id: "mode",
        header: "Mode",
        Header: () => <div className="table-title">MODE</div>,
        accessorFn: (row) => (
          <Link className="link-clear" to={`./${row.idSession}`}>
            {row.mode}
          </Link>
        ),
        enableColumnFilter: false,
        size: 80,
      },
      {
        id: "timeSpend",
        header: "Time Spend",
        Header: () => <div className="table-title">TIME SPENT (MM:SS)</div>,
        accessorFn: (row) =>
          row.duration ? moment(row.duration * 1000).format("m:ss") : "00:00",
        enableColumnFilter: false,
        size: 50,
      },
      {
        header: "results",
        Header: () => <div className="table-title">PROGRESS</div>,
        accessorKey: "score",
        enableColumnFilter: false,
        size: 80,
      },
      {
        header: "IA Analysis",
        Header: () => <div className="table-title">AI ANALYSIS</div>,
        accessorFn: (row) =>
          row.iaresult && row.iaresult.length > 0 ? (
            <IconButton
              role="img"
              aria-label="check"
              onClick={() => handleRowClick(row.iaresult)}
              style={{ cursor: "pointer", textAlign: "center", width: "100%" }}
              edge="end"
            >
              <Visibility />
            </IconButton>
          ) : (
            <span role="img" aria-label="cross"></span>
          ),
        enableColumnFilter: false,
        size: 50,
      },
    ],
    [],
  );

  return (
    <Table
      data={reportUser.reverse()}
      height="clamp(3rem, 53vh, 50rem)"
      columns={columns}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    reportUser: state.metricIndividualReducer.reportUser.reportUser,
  };
};

export default connect(mapStateToProps, null)(DetailsTable);
